export default "__VITE_ASSET__kom_SAFy__"